import React, { memo } from 'react';

import Popup from '../../helpers/Popup';
import Button from '../../helpers/Button';
import BaseInput from '../../helpers/Input';
import FormGroup from '../../helpers/FormGroup';
import useRequiredFieldErrors from '../../../hooks/useRequiredFieldErrors';
import DisplayError from '../../decorators/DisplayError';

import style from './style.module.css';

const Input = DisplayError(BaseInput);

const CeoOutreachReportPopup = props => {
  const { onOk, onChange, dates } = props;
  const { errors: requiredErrors, formProps } = useRequiredFieldErrors();
  const header = 'Download Ceo Outreach Report';
  const footer = (
    <Button className="btn-primary" onClick={onOk} type="button">
      Download
    </Button>
  );

  return (
    <Popup className={style.host} footer={footer} header={header} id="OutreachPopup">
      <form onSubmit={onOk} {...formProps}>
        <div className="row">
          <FormGroup className="col-sm-6">
            <Input
              error={requiredErrors['popupDates.from']}
              label="From"
              maxDate={dates.get('to')}
              name="popupDates.from"
              onChange={onChange}
              placeholder="From"
              type="date"
              value={dates.get('from')}
              autoFocus
              required
              showLabel
            />
          </FormGroup>

          <FormGroup className="col-sm-6">
            <Input
              error={requiredErrors['popupDates.to']}
              label="To"
              minDate={dates.get('from')}
              name="popupDates.to"
              onChange={onChange}
              placeholder="To"
              type="date"
              value={dates.get('to')}
              required
              showLabel
            />
          </FormGroup>
        </div>
      </form>
    </Popup>
  );
};

export default memo(CeoOutreachReportPopup);
